import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import Dialog from 'next/javascripts/components/dialog';
import 'next/stylesheets/components/portfolio/field-dialog.scss';

Component('tr-portfolio-field-dialog', {
  extends: [Dialog],

  mixins: [eventListenerMixin],

  ready() {
    this.listenTo(
      this.querySelector('tr-tabs'),
      'tr-tabs:activated',
      this.activateTabPane.bind(this),
    );
  },

  activateTabPane(event) {
    const { tab } = event.detail;

    [...this.querySelectorAll('.tab-content .tab-pane')].forEach((pane) => {
      pane.classList.toggle('hide', tab.dataset.name !== pane.dataset.tab);
    });
  },

  disconnected() {
    this.stopListening();
  },
});
